import { InputFieldRow } from "../InputFields.types.ts";
import DotLegalDeleteDialogWrapper from "../../../common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper.tsx";
import { useInputFieldDeleteDialog } from "./InputFieldDeleteDialog.hooks.ts";
import { useTranslation } from "../../../localization/useTranslation.ts";

export interface InputFieldDeleteDialogProps {
    inputFieldToDelete: InputFieldRow;

    onCloseDialog: () => void;
    onDeleted: () => void;
}

function InputFieldDeleteDialog(props: InputFieldDeleteDialogProps) {
    const { translateString } = useTranslation();
    const { inProgress, onDelete } = useInputFieldDeleteDialog(props);

    return (
        <DotLegalDeleteDialogWrapper
            inProgress={inProgress}
            itemForDeletion={props.inputFieldToDelete.name}
            open
            onDialogClose={props.onCloseDialog}
            onOkClick={onDelete}
            additionalWarning={translateString("deleteInputFieldWarning")}
        />
    );
}

export default InputFieldDeleteDialog;
